import React, { FC } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { forDesktop } from '@westwing/ui-kit/breakPoints';
import useBellaTranslator from '../../../hooks/useTranslator';
import { useOverlayUrlService } from '../useOverlay';
import { MenuSectionInterface } from './types';
import MenuItem from './MenuItem';
import MenuSection from './MenuSection';
import { remoteLoginEvent } from 'Common/events/service';
import { ACCOUNT_SECTION_KEY } from 'Client/components/OneHeader/Overlays/BurgerFlyout/initialMenuItem';
import StateInterface from 'Client/redux/types';
import useLoginAndRegisterOverlayWithTracking from 'Client/hooks/useLoginAndRegisterOverlayWithTracking';

const MenuContainer = styled.div`
    ${forDesktop`
        padding: 15px 20px;
    `}
`;
const StyledAccountSectionMenuItem = styled(MenuItem)`
    border-bottom: 1px solid rgba(242, 242, 240, 0.2);
    margin: 0 20px;
`;

interface Props {
    menuSections: MenuSectionInterface[];
    closeMenuFn: () => void;
    bordered?: boolean;
    search?: boolean;
    className?: string;
}

const Menu: FC<Props> = ({ className, menuSections, closeMenuFn, bordered, search }) => {
    const isLoggedIn = useSelector<StateInterface, boolean>(state => state.appShellLogin.isLoggedIn);
    const t = useBellaTranslator();
    const remoteLogin = remoteLoginEvent();
    const { pullOffOverlay } = useOverlayUrlService();
    const { showLoginAndRegisterOverlay, trackLoginOverlayShow } = useLoginAndRegisterOverlayWithTracking();
    const handleLoginMenuItemClick = () => {
        pullOffOverlay();
        closeMenuFn();
        showLoginAndRegisterOverlay();
        trackLoginOverlayShow();
        remoteLogin();
    };
    return (
        <MenuContainer className={className}>
            {menuSections.map(section => {
                return (
                    <MenuSection
                        key={section.key}
                        title={section.title ? section.title : ''}
                        isFullWidthSection={section.key === ACCOUNT_SECTION_KEY}
                        bordered={bordered}
                        search={search}
                    >
                        {section.items.map(menuItem => {
                            if (section.key === ACCOUNT_SECTION_KEY) {
                                return (
                                    <StyledAccountSectionMenuItem
                                        key={menuItem.title}
                                        title={isLoggedIn ? menuItem.title : t('Anmelden')}
                                        url={menuItem.url}
                                        itemType={menuItem.itemType}
                                        onClick={isLoggedIn ? menuItem.navDownCallback : handleLoginMenuItemClick}
                                        hexColor={menuItem.hexColor}
                                        className={menuItem.className}
                                        testId={menuItem.testId}
                                    />
                                );
                            }
                            return (
                                <MenuItem
                                    key={menuItem.title}
                                    title={menuItem.title}
                                    url={menuItem.url}
                                    itemType={menuItem.itemType}
                                    trackItemClick={menuItem.trackItemClick}
                                    onClick={menuItem.navDownCallback}
                                    closeMenuFn={closeMenuFn}
                                    highlighted={menuItem.highlighted}
                                    hexColor={menuItem.hexColor}
                                    fullLoginRequired={menuItem.fullLoginRequired}
                                    className={menuItem.className}
                                    testId={menuItem.testId}
                                />
                            );
                        })}
                    </MenuSection>
                );
            })}
        </MenuContainer>
    );
};
export default Menu;
